<template>
  <div id="view-footer">
    <template v-if="getTheme.footer.options.version !== 'CustomFooter'">
      <cms-footer
        v-if="footerSetUp"
        :theme="footerOptions"
        :content="getHomepage.footer"
        :organizations="getOrganizations"
        :current-domain="getHost"
        :ios-link="getIOSLink"
        :android-link="getAndroidLink"
      />
    </template>
    <template v-else>
      <cms-footer
        :theme="footerOptions"
        :content="getHomepage.footer"
        :organizations="getOrganizations"
        :current-domain="getHost"
        :ios-link="getIOSLink"
        :android-link="getAndroidLink"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { isEmpty } from 'lodash';

const store = useStore();

const getHomepage = computed(() => store.getters.getHomepage);
const getTheme = computed(() => store.getters.getTheme);
const getOrganizations = computed(() => store.getters.getOrganizations);
const getIOSLink = computed(() => store.getters.getIOSLink);
const getAndroidLink = computed(() => store.getters.getAndroidLink);
const getHost = computed(() => store.getters.getHost);

const footerSetUp = computed(() => getHomepage.value.footer && !isEmpty(getHomepage.value.footer));

const footerOptions = computed(() => ({
  ...getTheme.value.footer.options,
  translations: store.getters['translation/getComponentTranslation']('footer'),
}));
</script>

<style scoped lang="scss"></style>
